import { render, staticRenderFns } from "./bags.vue?vue&type=template&id=11b9ab95&scoped=true&"
import script from "./bags.vue?vue&type=script&lang=js&"
export * from "./bags.vue?vue&type=script&lang=js&"
import style0 from "./bags.vue?vue&type=style&index=0&id=11b9ab95&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b9ab95",
  null
  
)

export default component.exports